var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEditIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "r459qlsnja",
    d: "M2.5 14.375V17.5h3.125l9.217-9.217-3.125-3.125L2.5 14.375zm14.758-8.508c.325-.325.325-.85 0-1.175l-1.95-1.95c-.325-.325-.85-.325-1.175 0l-1.525 1.525 3.125 3.125 1.525-1.525z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-1153 -63) translate(0 40.613) translate(970) translate(183 22) translate(0 .5)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "l4mthzbmlb",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#r459qlsnja"
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#A6A6A6",
    mask: "url(#l4mthzbmlb)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0H41.667V41.667H0z",
    transform: "translate(-10.833 -10.833)"
  }))))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditIcon);
export default __webpack_public_path__ + "static/media/edit-icon.804575b4c3c9615ec4e37e3aa72123b2.svg";
export { ForwardRef as ReactComponent };